import axios from 'axios';
import { alertController, modalController } from '@ionic/vue';
import myConfig from './config';
import Message from '@/views/other/MessageModal.vue';
import PageDialog from '@/components/PageDialog.vue';
import store from '@/js/store';

//****************************************************
axios.defaults.baseURL = myConfig.config.API_ADDRESS;
//****************************************************

async function presentAlert(message: string) {
    const alert = await alertController.create({
        header: '提示信息',
        message: message,
        buttons: ['确定'],
        backdropDismiss: false
    });
    return alert.present();
}

axios.interceptors.response.use(async success => {
    if (success && success.data) {
        if (success.data.success) {
            if (success.data.message) {
                await presentAlert(success.data.message);
            }
        } else {
            if (success.data.message) {
                if(success.data.code === 9001){
                   const  ossUrl=store.getOEMUrl() + '/app/';
                    const modal = await modalController.create({
                        component: PageDialog,
                        componentProps: {
                            title: "温馨提示",
                            message: `<div style="display: flex;flex-direction: column;align-items: center;">
                                         <p style="margin-top: 0">${success.data.message}</p>
                                         <image src="${ossUrl}customer.png" style="width: 11rem;height: 11rem;"></image></div>`,
                            type: "",
                            hasHtml:true },
                        cssClass: "center_modal_controller_class4",
                        backdropDismiss: false,
                    });
                    await modal.present()
                }
                else  if(success.data.code === 10002||success.data.code === 101) {
                    await presentAlert(success.data.message);
                        await store.clearSession();
                        location.replace("/Login");
                    }
                else{
                    await presentAlert(success.data.message);

                }
            }
        }
    } else {
        alert(success);
    }

    return success;

}, async error => {
    console.log(error)
    alert("系统检测到网络连接不畅，请切换更佳的网络，点击“OK”继续上课！");
    // await presentAlert("权限不足！");
    //location.replace("/login");
    return;
});
export default {

    baseUrl: axios.defaults.baseURL,                     //java地址
    printURL: myConfig.config.PRINT_ADDRESS + "/print/pc.html",  //打印地址
    baseWS: myConfig.config.WSS_ADDRESS,

    post(url: string, data: object, authorization?: string, headers?: any, params?: any) {
        let token = localStorage.getItem("token");
        if (token == null) {
            token = "";
        }

        axios.defaults.headers.common['Authorization'] = authorization ? authorization : token;
        axios.defaults.headers.common["Domain"] = myConfig.config.hostname  as string;
        return axios({
            method: 'post',
            url: url,
            data: data,
            headers,
            params
        });
    },

    get(url: string) {
        let token = localStorage.getItem("token");
        if (token == null) {
            token = "";
        }

        axios.defaults.headers.common['Authorization'] = token;
        axios.defaults.headers.common["Domain"] = myConfig.config.hostname  as string;
        return axios.get(url);
    },

    download(url:string, filename:string, params?:object) {
        axios.defaults.headers.common['Authorization'] = localStorage.getItem("token") as string;
        axios({
            method: 'post',
            url: url,
            data: params,
            responseType: 'blob'
        }).then(res => {
            const elink = document.createElement('a');
            elink.download = `${filename}_${new Date().getTime()}.xlsx`;
            elink.style.display = 'none';
            const blob = new Blob([res.data], {type: 'application/x-msdownload'});
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
        });

    }
}

